import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MenuLink from './menuLink';
import salom_logo from '../../../shared/assets/images/logo_admin_salom.png';
import Sidebar from './sidebar';
import './Navbar.scss';
import IconBurger from '../../../components/icon/IconBurger';

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      full_name: localStorage.getItem('salom::admin::full_name'),
    };
  }

  render() {
    return (
      <div className="top-bar">
        <nav className="navbar navbar-expand-lg navbar-light fixed-top admin-navbar">
          {/* <a className="navbar-brand" href="/admin">
                            <img src={salom_logo} alt="Salom" />
                        </a> */}
          <button
            className="btn btn-outline-secondary sidebar-toggle-btn"
            onClick={this.props.toggleSidebar}
          >
            <span className="">
              <IconBurger />
            </span>
          </button>
          <button
            className="navbar-toggler hide-lg"
            type="button"
            data-toggle="collapse"
            data-target="#salom-admin-navbar"
            aria-controls="salom-admin-navbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="salom-admin-navbar">
            <ul className="navbar-nav mr-auto">
              {/* <MenuLink activeOnlyWhenExact={true} to="/admin" label="Dashboard" />
                            <MenuLink to="/admin/categories" label="Категории" />
                            <MenuLink to="/admin/partners" label="Партнеры" />
                            <MenuLink to="/admin/cities" label="Города" />
                            <MenuLink to="/admin/periods" label="Периоды" />
                            <MenuLink to="/admin/contacts" label="Контакты партнеров" /> */}
            </ul>
            <ul className="navbar-nav navbar-right">
              <li className="nav-item">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {this.state.full_name}
                </a>
                <div
                  className="dropdown-menu dr-menu"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <Link className="dropdown-item" to="/admin/updatepassword">
                    Изменить пароль
                  </Link>
                  <a className="dropdown-item" href="#/">
                    Перейти на сайт
                  </a>
                  <a className="dropdown-item" href="#/login">
                    Выйти
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <br />
        <br />
        <br />
        <br />
        <Sidebar toggle={this.props.toggle} />
      </div>
    );
  }
}

export default Navbar;
